<template>
  <div class="vr">
    <div class="Header">
      <div class="container">
        <div class="logo"><a href="https://www.henglvwang.cn"><img src="../assets/images/logo.png" class="img"></a></div>
        <div class="navs">
          <a v-for="(item, index) in lang.navs" :class="`li ${item.isActive? 'active':''}`" :key="index" :href="item.url">{{item.name}}</a>
        </div>
        <div class="lang">
          <div v-for="(item, index) in tabs" :class="`li ${item.isActive? 'active':''}`"  :key="index" @click="switchLang" :data-key="`${item.key}`">{{item.name}}</div>
        </div>
        <div class="langs">
          <div v-for="(item, index) in tabs" :key="index" @click="switchLang" :data-key="`${item.key}`">{{ item.isActive? '': item.text}}</div>
        </div>
      </div>
    </div>
    <div class="bg">
      <div class="t-1"></div>
      <div class="b-2"></div>
      <div class="title">
        <div class="i"></div>
        
        <div class="desc">{{lang.d1}}</div>
      </div>
      <div class="container">
        <a class="left" :href="`${url}`">
          <img :src="img" class="img vr"/>
          <div class="i"></div>
        </a>
        <div class="right">
          <div class="tit">
            <div class="i"></div>
            
            <div class="desc">{{lang.add}}{{lang.t1}}<span>{{lang.t2}}</span></div>
          </div>
          <div class="content">{{lang.d1}}{{lang.content}}</div>
        </div>
      </div>
      <a href="./" class="return">{{lang.return}}</a>
    </div>
    <div class="copyright">{{lang.copyright}}</div>
  </div>
</template>
<script>
import langs from "@/lang/index.js"
export default {
  name: "vr1",
  data () {
    return {
        img: 'http://hlw-1254378658.piccd.myqcloud.com/VR-01.jpg',
        lang: langs['zh'].vr1,
        tabs: [{
        key: "en",
        text: 'EN',
        name: "English",
        isActive: false
      },{
        key: "zh",
        text: '中',
        name: "中文",
        isActive: true
      }],
      url: 'https://720yun.com/t/00vkOq2wpfq?scene_id=55865344',
    }
  },
  mounted (){
    document.title = this.lang.title
  },
  methods: {
    switchLang(e) {
      let tabs = this.tabs
      console.log(e)
      for(let i = 0, len = tabs.length;i < len; i++){
        if(e.target.dataset.key == tabs[i].key){
          tabs[i].isActive = true
          this.lang = langs[tabs[i].key].vr1
          document.title = this.lang.title
        }else{
          tabs[i].isActive = false
        }
      }
      this.tabs = tabs

    }
  }
}
</script>
<style lang="scss" scoped>
html {
  font-size: 100px;
}
.img{
    width: 100%;
    height: 100%;
    display: block;
  }
.vr{
    border-radius: 1vw;
}
.Header{
  width: 100vw;
  height: 6vw;
  background:#000753;
  
  .container{
    width: 63vw;
    height: auto;
    margin: 0 auto;
    position: relative;
    z-index: 2;
    .navs{
      width: 30vw;
      position: absolute;
      top: 2.7vw;
      left: 16vw;
      z-index: 2;
      .li{
        width: 20%;
        font-size: 1vw;
        color: #fff;
        display: block;
        float: left;
        position: relative;
        text-align: center;
        
          &:hover{
            &::after{
            content: ' ';
            position: absolute;
            background: #00E2CE;
            height: 2px;
            width: 2vw;
            bottom: -1vw;
            margin: 0 auto;
            left: 0;
            right: 0;
          }
        }
        &.active::after{
          content: ' ';
          position: absolute;
          background: #00E2CE;
          height: 2px;
          width: 2vw;
          bottom: -1vw;
          margin: 0 auto;
          left: 0;
          right: 0;
        }
      }
    }
  }
  .logo{
    width: 10.8vw;
    height: 4.2vw;
    padding-top: 1vw;
  }
  .langs{
    display: none;
  }
  .lang{
    padding: 2vw;
    width: 30vw;
    position: absolute;
    right: 0;
    top: 0;
    .li{
      width: 5.5vw;
      height: 2vw;
      background: #FFFFFF;
      border: 1px solid #0D0BAD;
      border-radius: 24px;
      line-height: 2.2vw;
      text-align: center;
      font-size: 0.9vw;
      color: #0D0BAD;
      float: right;
      margin-left: 10px;
      transition: all .3s ease-in-out;
      cursor: pointer;
      &.active{
        background-image: linear-gradient(180deg, #0E0BAF 0%, #000353 100%);
        border-radius: 24px;
        color: #fff;
      }
    }
  }
}
.copyright{
  width: 100vw;
  font-size: 14px;
  color: rgba(255,255,255,0.29);
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 15px;
}
.bg{
  width: 100vw;
  height: calc(100vh - 6vw);
  background: #000753 100%;
  position: relative;
  .return{
    position: absolute;
    top: 72vh;
    width: 9.5vw;
    height: 3.5vw;
    font-size: 1.1vw;
    border-radius: 4vw;
    text-align: center;
    left: 0;
    right: 0;
    margin: 0 auto;
    line-height: 3.5vw;
    background: #0015BF;
    color: #00E2CE;
    font-weight: bold;
    transition: all .3s ease-in-out;
    &:hover{
      top: 71vh;
      transition: all .3s ease-in-out;
    }
  }
  .container{
    position: absolute;
    margin: 0 auto;
    text-align: center;
    background: #F7F7F7;
    border-radius: 20px;
    width: 56vw;
    top: 19vh;
    left: 0;
    right: 0;
    padding: 1vw;
    .left{
      width: 66%;
      margin-right: 2.5%;
      float: left;
      position: relative;
      .img{
        width: 100%;
        height: 100%;
        display: block;
      }
      .i{
        position: absolute;
        width: 6.5vw;
        height: 6.5vw;
        background-image: url('../assets/images/btn-vr-enter.png');
        background-position: center;
        background-size: cover;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        animation: 1s pulse infinite;
      }
    }
    .right{
      width: 26.7%;
      background: #FFFFFF;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
      border-radius: 15px;
      padding: 1vw;
      float: left;
      text-align: left;
      .tit{
        width: 100%;
        float: left;
        .t{
          font-size: 1.2vw;
          color: #000000;
          line-height: 2vw;
        }
        .i{
          width: 1.1vw;
          height: 1.2vw;
          float: left;
          background-image: url('../assets/images/i-vr.png');
          background-size: cover;
          margin-right: 10px;
        }
        .desc{
          font-size: 1.2vw;
          color: #040672;
          font-weight: bold;
          line-height: 1.5vw;
          width: 100%;
          span{
            font-size: 1vw;
            color: #0D0AA8;
            float: right;
            line-height: 2vw;
          }
        }
      }
      .content{
        width: 100%;
        font-size: 0.9vw;
        color: #010457;
        line-height: 1.5vw;
        text-align: justify;
        overflow-y: scroll;
        height: 16.6vw;
        float: left;
      }
    }
  }
  .t-1{
    width: 65.5vw;
    height: 19.5vw;
    background-image: url("../assets/images/bg-top-02.png");
    background-size: cover;
    position: absolute;
    left: 10vw;
    top: -6vw;
    animation: 10s heartBeat infinite;
  }
  .b-2{
    width: 4.9vw;
    height: 25.9vw;
    background-image: url("../assets/images/bg-right.png");
    background-size: cover;
    position: absolute;
    right: 0;
    bottom: 0;
    animation: 5s flash infinite;
  }
  .title{
    width: 100%;
    position: absolute;
    top: 60px;
    left: 25vw;
    .i{
      width: 1.6vw;
      height: 2vw;
      background-image: url("../assets/images/i-t-01.png");
      background-size: cover;
      position: absolute;
      left: -2.6vw;
    }
    .name{
      font-size: 4vw;
      color: #FFFFFF;
      font-weight: bolder;
      display: inline;
    }
    .desc{
      font-size: 2.5vw;
      color: #fff;
      font-weight: bold;
      line-height: 4vw;
      display: inline;
      padding-left:0.5vw;
    }
  }
}
@media (max-width: 1024px){
  body{font-size: 18px}
  .vr{
    border-radius: 3vw;
    }
  .Header{
    width: 100%;
    height: 17vw;
    .logo{
      width: 24vw;
      height: 9vw;
      margin: 0 auto;
      position: absolute;
      left: 0;
      right: 0;
      top: 3vw;
    }
    .container{
      width: 100%;
      .navs{
        width: 85vw;
        top: 16.5vh;
        left: 8vw;
        .li{
          width: 22%;
          font-size: 3vw;
          border: 2px solid #000CC4;
          color: #00E1CD;
          border-radius: 15px;
          padding: 2vw 0;
          margin-left: 1vw;
          &.active{
            background: #000CC4;
            color: #00E1CD;
            &::after{
              display: none;
            }
          }
          &:hover{
            &::after{
              display: none;
            }
          }
        }
      }
    }
    .lang{
      display: none;
    }
    .langs{
      display: block;
      width: 8vw;
      height: 8vw;
      background: #010457;
      color: #fff;
      border: 2px solid #00C7AE;
      border-radius: 5px;
      font-size: 3vw;
      line-height: 8.5vw;
      text-align: center;
      position: absolute;
      right: 4vw;
      top: 4vw;
    }
  }
  .bg{
    height: calc(100vh - 17vw);
    width: 100%;
    .return{
      width: 25vw;
      height: 8vw;
      top: 78vh;
      font-size: 3vw;
      line-height: 8vw;
      &:hover{
        top: 78vh;
      }
    }
    .t-1{
      width: 94.5vw;
      height: 28.4vw;
      background-size: cover;
      left: -8vw;
      top:-17vw;
    }
    .b-2{
      width: 12vw;
      height: 64vw;
      background-size: cover;
    }
    .title{
      top: 1vw;
      left: 0;
      right: 0;
      margin: 0 auto;
      z-index: 0;
      text-align: center;
      .i{
        display: none;
        width: 4.2vw;
        height: 5vw;
        background-size: cover;
        position: absolute;
        left: 39vw;
      }
      .name{
        font-size: 7vw;
        left: 0;
        right: 0;
        margin: 0 auto;
        text-align: center;
      }
      .desc{
        font-size: 4vw;
        left: 0;
        right: 0;
        margin: 0 auto;
        text-align: center;
        top: 2vh;
        line-height: 8vw;
        display: block;
        padding-left: 0;
      }
    }
    .container{
      z-index: 0;
      width: 84vw;
      padding:3vw;
      top: 14.5vh;
      .box{
        width: 79vw;
        top: 15vh;
      }
      .left{
        width: 100%;
        margin-left: 0;
        margin-bottom: 3vw;
        .i{
          width: 20vw;
          height: 20vw;
        }
      }
      .right{
        width: 94%;
        padding: 3%;
        .tit{
          .i{
            width: 4vw;
            height: 4.8vw;
            background-size: cover;
          }
          .t{
            font-size: 4vw;
            line-height: 4vh;
          }
          .desc{
            font-size: 4.5vw;
            line-height: 5.5vw;
            span{
              float:none;
              padding-left: 3vw;
              font-size: 3vw;
            }
          }
        }
        .content{
          height: 22vh;
          font-size: 3.5vw;
          margin-top: 1.5vh;
          line-height: 5vw;
          text-indent: 0.5rem;
        }
      }
    }
  }
  .copyright{
    font-size: 8px;
    bottom: auto;
    top: 97vh;
  }
} 
@media (max-width: 1366px ) and ( min-width: 1024px){
    .bg{
        .return{
            top: 55vh;
            &:hover{
                top: 56vh;
            }
        }
    }
}
/*>=1024的设备*/
// @media (min-width: 1100px) {
//   body{font-size: 20px}
// } /*>=1024的设备*/
// @media (min-width: 1280px) {
//   body{font-size: 22px;}
// } 
// @media (min-width: 1366px) {
//   body{font-size: 24px;}
// }  
// @media (min-width: 1440px) {
//   body{font-size: 25px !important;}
// } 
// @media (min-width: 1680px) {
//   body{font-size: 28px;}
// } 
// @media (min-width: 1920px) {
//   body{font-size: 33px;}
// } 
</style>